import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment/moment'

import { UNIT_TYPES } from 'constants'
import { getBattlesNotHeldMessage, getNextBattleMessage } from './helpers'
import styles from './BattlesNotHeldMessage.scss'

const BattlesNotHeldMessage = props => {
    const { playdayEnd, playdays, playdayStart, unitType, vehicleLevel } = props
    const currentHour = moment.utc().hour()

    const notHeldMessage = getBattlesNotHeldMessage(unitType, vehicleLevel)
    const nextBattleMessage = getNextBattleMessage(playdays, playdayStart, playdayEnd, unitType, currentHour)
    return (
        <span className={styles.base}>
            {notHeldMessage}
            &nbsp;
            <span className={styles.highlightedText}>{nextBattleMessage}</span>
        </span>
    )
}

BattlesNotHeldMessage.propTypes = {
    playdayEnd: PropTypes.number,
    playdays: PropTypes.array,
    playdayStart: PropTypes.number,
    unitType: PropTypes.oneOf(Object.values(UNIT_TYPES)),
    vehicleLevel: PropTypes.number,
}

export default BattlesNotHeldMessage



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleRoomsSchedule/components/BattlesNotHeldMessage/BattlesNotHeldMessage.jsx